import { useParams } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { TrainingDocumentsFileViewerDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { FileViewer, File as FileViewerFile } from 'modules/trainings/components/Files/FileViewer'

export default function TrainingFileViewer() {
  const { id, fileId } = useParams<{
    id: string
    fileId: string
  }>()
  const { navigation } = useNavigation()
  const { data, loading } = useQuery(TrainingDocumentsFileViewerDocument, {
    variables: {
      trainingId: String(id),
    },
  })
  const files =
    data?.trainings?.trainingFilesConnection?.nodes.map((file) => ({
      id: file.id,
      filename: file.filename,
      title: file.title,
      fileUrl: file.url,
      contentType: file.contentType,
      url: file.url,
      type: 'training' as const,
    })) ?? []

  const currentFile = files.find((f) => f.id === String(fileId))

  if (loading) return null

  return (
    <FileViewer
      file={currentFile}
      files={files}
      urlBackTo={navigation.trainings.list.details_revamp.view.documents.fullPath({
        id: id || '',
      })}
      goNextFile={(nextFileInViewer: FileViewerFile): string => {
        if (nextFileInViewer && nextFileInViewer.id) {
          return navigation.trainings.list.details_revamp.view.documents.previewFile.fullPath({
            id: id || '',
            fileId: String(nextFileInViewer.id),
          })
        }
        return '#'
      }}
      goPrevFile={(prevFileInViewer: FileViewerFile): string => {
        if (prevFileInViewer && prevFileInViewer.id) {
          return navigation.trainings.list.details_revamp.view.documents.previewFile.fullPath({
            id: id || '',
            fileId: String(prevFileInViewer.id),
          })
        }
        return '#'
      }}
    />
  )
}
